module.exports = __webpack_public_path__ + "img/1545445798.5bb26327.jpg";